import React from 'react';
import './index.css';
import Cards from '../cards';
import Table from '../table/index'

function MainDash() {
  return (
    <div className='main-dash-container'>
        <h1>Dashboard</h1>
        <Cards/>
        <Table/>
    </div>
  )
}

export default MainDash;
